import { api } from '@/api';
import { RootState } from '@/store/index';
import { Advertising } from '@/types/Advertising';
import { ActionContext, Module } from 'vuex';

export type AdvertisingsState = {
    advertisings: Advertising[];
};

export const advertisings: Module<AdvertisingsState, RootState> = {
    state: {
        advertisings: [],
    },
    mutations: {
        setAdvertisings(state: AdvertisingsState, payload) {
            state.advertisings = payload;
        },
    },
    getters: {
        advertisings: (state) => state.advertisings,
    },
    actions: {
        async fetchAdvertisings(context: ActionContext<AdvertisingsState, RootState>) {
            const response = await api.get('/advertisings');

            if (!response || !response.data) {
                throw new Error('Could not load advertisings');
            }

            context.commit('setAdvertisings', response.data.data);
        },
    },
};
